module.exports = __webpack_public_path__ + "images/dingtalk/topic@2x-86a6d59dc621f3b769f362a1fe4dfcec.png";